import styles from "./styles/RefContainer.module.css";

const RefContainer = ({ theRef, id, text, children }) =>
{
    return (
        <div ref={theRef} id={id} className={styles.refContainer}>
            <div className={styles.header} >
                {text}
            </div>
            {children}
        </div>
    )
}

export default RefContainer;